export const jpResetPassword = {
  SC52title: 'パスワードの再設定',
  SC52heading1: '新しいパスワードを入力してください。',
  SC52heading2: 'パスワードは半角英数と数字の両方を含む、8桁以上で入力してください。',
  SC52typeAgain: 'もう一度入力してください。',
  SC52errorResetPassword: 'パスワードの再設定失敗しました。',
  SC52heading: '新しいパスワードを入力してください。',
  SC52notice: 'パスワードは半角英数と数字の両方を含む、8桁以上で入力してください。',
}
